import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "flex flex-row gap-2" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "flex-2" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { toast } from "@/common/utils/toast";

import { maskPhone } from "@/common/utils/mask";

import { baseInput, baseSelect, baseTextarea } from "@/common/components";

import type { ContactType } from "@/common/types/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'contact',
  props: {
    data: {},
    title: {},
    width: { default: "100%" }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  name: "",
  type: "",
  contact: "",
  description: "",
};

const payload = ref<ContactType>({ ...defaultData });

const typeOptions = computed(() => [
  { value: "phone", option: t("common.labels.phone") },
  { value: "email", option: t("common.labels.email") },
  { value: "other", option: t("common.labels.other") },
]);

function update() {
  emit("update-data", payload.value);
}

function typeMask(value: string) {
  if (payload.value.type === "phone") return maskPhone(value);

  return value;
}

function placeholder() {
  if (payload.value.type === "phone") {
    return "(00) 00000-0000";
  }

  if (payload.value.type === "email") {
    return "example@example.com";
  }

  return "";
}

watchEffect(() => {
  if (props.data) {
    payload.value = { ...props.data };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " * ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(baseSelect), {
            modelValue: payload.value.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.type) = $event)),
            value: payload.value.type,
            options: typeOptions.value,
            onChange: _cache[3] || (_cache[3] = ($event: any) => (update()))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")) + " * ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(baseInput), {
            modelValue: payload.value.contact,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.contact) = $event)),
            value: payload.value.contact,
            mask: typeMask,
            placeholder: placeholder(),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (update()))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.contact")) + " * ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "placeholder"])
        ])
      ]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        onInput: _cache[7] || (_cache[7] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"])
    ])
  ], 4))
}
}

})